import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/Documentation/Documentation/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2 {...{
      "id": "create-droplet"
    }}>{`Create droplet`}</h2>
    <ol>
      <li parentName="ol">{`Click `}<strong parentName="li">{`Create droplet`}</strong></li>
    </ol>
    <ul>
      <li parentName="ul">{`Choose an image: `}<inlineCode parentName="li">{`Ubuntu 18.04.4 x64`}</inlineCode></li>
      <li parentName="ul">{`Choose a size: `}<inlineCode parentName="li">{`2 GB (RAM), 1 vCPU, 50 GB (SSD)`}</inlineCode></li>
      <li parentName="ul">{`Choose a datacenter region: `}<inlineCode parentName="li">{`San Francisco`}</inlineCode></li>
    </ul>
    <ol {...{
      "start": 2
    }}>
      <li parentName="ol">{`Then SSH to droplet.`}</li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      